import React from "react";
import { noImage } from "assets";
import { formatUah } from "utils/format";

// Компонент відображення рядка товару-переводу
const TrapProductInlineRow = ({ product, isSelectionModeActive, isLast, onImageClick }) => {
  return (
    <tr className="product-inline-row">
      {isSelectionModeActive && <td></td>}
      {/* Товарів — зв'язок дерево */}
      <td className="tree-cell">
        <span className="tree-line">{isLast ? "└" : "├"}</span>
      </td>
      {/* Фото */}
      <td>
        <img
          src={product.img_url || noImage}
          className={product.img_url ? "clickable" : ""}
          onClick={() => onImageClick(product.img_url)}
          alt={product.name || product.product_sku}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noImage;
          }}
        />
      </td>
      {/* Назва — без риски */}
      <td>{product.name || "N/A"}</td>
      {/* Магазин — пусто */}
      <td></td>
      {/* SKU */}
      <td style={{ whiteSpace: "pre" }}>{product.product_sku}</td>
      {/* Категорія — пусто */}
      <td></td>
      {/* Ціна */}
      <td>{product.price != null ? formatUah(product.price) : ""}</td>
      {/* Присутність — залишки */}
      <td>{product.quantity ?? ""}</td>
      {/* Авто — пусто */}
      <td></td>
      {/* Дії — пусто */}
      <td></td>
    </tr>
  );
};

// Рядок завантаження
const LoadingInlineRow = ({ colSpan }) => (
  <tr className="product-inline-row skeleton-row">
    <td colSpan={colSpan}></td>
  </tr>
);

export { TrapProductInlineRow, LoadingInlineRow };
